export enum AppointmentStatuses {
  Old,
  Future14Days,
  Unconfirmed,
  UnconfirmedWebsite,
  FollowUpRequired,
  RemindersDue,
  Cancelled,
  FutureAll,
}
